import * as React from "react";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { AdviceTypeArrays, AdviceTypeArraysMap } from "../Resource/Contents";
import { SectionHeader } from "../SharedComponents";

interface IAdviceTypeProps extends IProcessComponentProps {
    readOnly: boolean;
}

interface IAdviceTypeStates {}

export class AdviceType extends ProcessComponent<IAdviceTypeProps, IAdviceTypeStates> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data, readOnly } = this.props;
        const { AccountAdviceType } = data;
        return (
            <>
                {SectionHeader(
                    "Advice type",
                    "For use when client has selected to receive a discretionary investment service."
                )}
                <RadiosEditor
                    cssWrapper="radio-group rg-inline rg-180"
                    selected={AccountAdviceType}
                    options={AdviceTypeArrays}
                    getText={(v) => {
                        return AdviceTypeArraysMap[v];
                    }}
                    onChange={(v) => {
                        this.props.onChange({ AccountAdviceType: v });
                    }}
                    required="Please choose advice type"
                    disabled={readOnly}
                    infoText={"Setting the advice type enables client groups to be segmented for bulk trade reporting."}
                />
            </>
        );
    }
}
